import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
export function SET_ARRAY(state, payload) {
  state[payload.state] = _toConsumableArray(payload.data);
}
export function PUSH_ARRAY(state, payload) {
  state[payload.state] = [].concat(_toConsumableArray(state[payload.state]), _toConsumableArray(payload.data));
}

/**
 * Add or remove single item from Array.
 *
 * @param state
 * @param payload | state, data, key
 * @constructor
 */
export function TOGGLE_ARRAY(state, payload) {
  var foundIndex = payload.key ? state[payload.state].findIndex(function (i) {
    return i[payload.key] === payload.data[payload.key];
  }) : state[payload.state].findIndex(function (i) {
    return i === payload.data;
  });
  foundIndex >= 0 ? state[payload.state].splice(foundIndex, 1) : state[payload.state].push(payload.data);
}

/**
 * Add or remove many items from Array.
 *
 * @param state
 * @param payload | state, data, set, key
 * @constructor
 */
export function TOGGLE_MANY_ARRAY(state, payload) {
  payload.data.forEach(function (item) {
    var foundIndex = payload.key ? state[payload.state].findIndex(function (i) {
      return i[payload.key] === item[payload.key];
    }) : state[payload.state].findIndex(function (i) {
      return i === item;
    });
    if (foundIndex === -1) {
      state[payload.state].push(item);
    } else if (foundIndex >= 0) {
      state[payload.state].splice(foundIndex, 1);
    } else {
      return false;
    }
  });
}
export function SET(state, payload) {
  state[payload.state] = payload.data;
}

/**
 * Set related CUIs/WUIs to an n-gram.
 *
 * @param state
 * @param payload
 * @constructor
 */
export function UPDATE_NGRAM(state, payload) {
  var foundIndex = state.nGrams.findIndex(function (n) {
    return n.id === payload.data.id;
  });
  if (foundIndex >= 0) {
    var newNGram = state.nGrams[foundIndex];
    newNGram.progress_completed = payload.data.progress_completed;
    newNGram.progress_total = payload.data.progress_total;
    if (payload.updateContent) {
      newNGram[payload.itemsKey] = payload.data[payload.itemsKey];
    }
    Vue.set(state.nGrams, foundIndex, newNGram);
  }
}

/**
 * Update n-gram progresses.
 * @param state
 * @param {Array.<Object>} payload
 * @constructor
 */
export function UPDATE_NGRAM_PROGRESSES(state, payload) {
  var foundNgram;
  var nGrams = state.nGrams.map(function (n) {
    foundNgram = payload.find(function (p) {
      return p.term === n.name;
    });
    if (foundNgram) {
      var _foundNgram = foundNgram,
        total = _foundNgram.total,
        completed = _foundNgram.completed;
      n.progress_total = total;
      n.progress_completed = completed;
      return n;
    }
  });
  if (foundNgram) {
    state.nGrams = _toConsumableArray(nGrams);
  }
}

/**
 * Update StateId on Wuis or Cuis items in NGrams
 *
 * @param state
 * @param payload
 * @constructor
 */
export function UPDATE_NGRAM_ITEM_STATE(state, payload) {
  var modelId = +payload.model_id;
  var auditId = +payload.id;
  var source = state.concept + 's';
  var nGramModel = state.nGrams.find(function (n) {
    return n[source].find(function (cw) {
      return cw.id === modelId;
    });
  });
  if (nGramModel) {
    var nGramIndex = state.nGrams.findIndex(function (e) {
      return e.id === nGramModel.id;
    });
    var index = state.nGrams[nGramIndex][source].findIndex(function (e) {
      return e.id === modelId;
    });
    if (index >= 0) {
      var nGram = state.nGrams[nGramIndex];
      nGram[source][index].audit_id = auditId;
      state.nGrams[nGramIndex] = nGram;
    }
  }
}

// N-grams
export function ASSIGN_N_GRAMS(state, payload) {
  state.nGrams = _toConsumableArray(state.nGrams.map(function (n) {
    if (payload.map(function (p) {
      return p.id;
    }).includes(n.id)) {
      n.user = payload.find(function (p) {
        return p.id === n.id;
      }).user;
      return n;
    }
    return n;
  }));
}
export function UNASSIGN_N_GRAMS(state, payload) {
  state.nGrams = _toConsumableArray(state.nGrams.map(function (n) {
    if (payload.map(function (p) {
      return p.id;
    }).includes(n.id)) {
      n.user = null;
      return n;
    }
    return n;
  }));
}
export function ADD_CONCEPT_DETAILS(state, payload) {
  state.conceptDetails = _objectSpread(_objectSpread({}, state.conceptDetails), _defineProperty({}, payload.data.id, payload.data));
}

/**
 * @param state
 * @param {Array} ids
 * @constructor
 */
export function REMOVE_CONCEPT_DETAILS(state, ids) {
  ids.forEach(function (id) {
    delete state.conceptDetails[id];
  });
}
export function MOVE_NON_MESH_CUI_TO_MESH(state) {
  state.cuisSelection.forEach(function (c) {
    state.nGrams.forEach(function (nGram) {
      var cuiIndex = nGram.cuis.findIndex(function (t) {
        return t.id === c.id;
      });
      if (cuiIndex >= 0) {
        nGram.cuis[cuiIndex].action = {
          approved: 0
        };
      }
    });
  });
}
export function SET_CONCEPT_QUERIES(state, payload) {
  state.conceptQueries = _toConsumableArray(payload.data);
  state.conceptQueriesMeta = payload.meta;
}
export function PUSH_CONCEPT_QUERIES(state, payload) {
  var _state$conceptQueries;
  (_state$conceptQueries = state.conceptQueries).push.apply(_state$conceptQueries, _toConsumableArray(payload.data));
  state.conceptQueriesMeta = payload.meta;
}
export function UPDATE_CONCEPT_QUERIES(state, payload) {
  var actionId = payload.data.action_id;
  payload.data.model_actions.forEach(function (ma) {
    var index = state.conceptQueries.findIndex(function (cq) {
      return cq.id === ma.entity.id;
    });
    if (index >= 0) {
      state.conceptQueries[index].action_id = actionId;
    }
  });
}
export function SET_SELECTED_CONCEPT(state, payload) {
  state.selectedConcept = {
    term: payload.term,
    id: payload.id,
    code: payload.code
  };
}
export function TOGGLE_EXPANDED(state, index) {
  var foundIndex = state.expanded.findIndex(function (i) {
    return i === index;
  });
  foundIndex >= 0 ? state.expanded.splice(foundIndex, 1) : state.expanded.push(index);
}
export function TOGGLE_EXPANDED_CONCEPT_QUERIES(state, index) {
  var foundIndex = state.expandedConceptQueries.findIndex(function (i) {
    return i === index;
  });
  foundIndex >= 0 ? state.expandedConceptQueries.splice(foundIndex, 1) : state.expandedConceptQueries.push(index);
}
export function REMOVE_EXPANDED(state, indexes) {
  indexes.forEach(function (index) {
    var foundIndex = state.expanded.findIndex(function (i) {
      return i === index;
    });
    if (foundIndex >= 0) {
      state.expanded.splice(foundIndex, 1);
    }
  });
}
export function CLEAR_EXPANDED(state) {
  state.expanded = [];
}
export function CLEAR_EXPANDED_CONCEPT_QUERIES(state) {
  state.expandedConceptQueries = [];
}
export function TOGGLE_MESH_PANEL(state) {
  state.showMeshPanel = !state.showMeshPanel;
}
export function FREEZE_PANEL(state, payload) {
  state.frozenPanels.push(payload);
}
export function UNFREEZE_PANEL(state, payload) {
  var foundIndex = state.frozenPanels.findIndex(function (f) {
    return f.code === payload.code && f.id === payload.id && f.term === payload.term;
  });
  state.frozenPanels.splice(foundIndex, 1);
}

/**
 *
 * @param state
 * @param {object} payload
 * @param {string} payload.state - target state
 * @param {string} payload.key - property by which to find the target
 * @param {object} payload.targets - targets object
 * @param {string} payload.prop - property to be changed
 * @param {*} payload.value - new value
 * @constructor
 */
export function UPDATE_PROPERTY(state, payload) {
  payload.targets.forEach(function (t) {
    // const found = state[payload.state].find(item => item[payload.key] === t[payload.key])
    // if (found) { found[payload.prop] = payload.value }
    var foundIndex = state[payload.state].findIndex(function (item) {
      return item[payload.key] === t[payload.key];
    });
    if (foundIndex >= 0) {
      var item = state[payload.state][foundIndex];
      item[payload.prop] = payload.value;
      Vue.set(state[payload.state], foundIndex, item);
    }
  });
}